// @flow
import * as React from 'react';
import styled from 'styled-components';
import Button from 'components/Button';
import { colors } from '../theme';

const DeleteButton = styled(({ isBannerWithOverlay, ...props }) => (
  <Button {...props} />
))`
  position: absolute;
  z-index: 1;
  ${props =>
    props.isBannerWithOverlay
      ? `
top: 20px;
right: 20px;
`
      : `
top: -13px;
right: -13px;
`}
  width: 25px;
  height: 25px;
  background-color: ${colors.waterBlue};
  background-image: url('/static/images/icons/trashcan-white.svg');
  background-size: 9px 10px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in;
  &:hover {
    background-color: ${colors.turtleGreen};
  }
`;

export default DeleteButton;
